import { useRef } from 'react';

// ponytail: referential stability matters here — React (dangerouslySetInnerHTML diff)
// compares the {__html} object by reference, not by string value. If createMarkup
// returned a new object every render, React would rewrite innerHTML on every unrelated
// re-render and destroy the StakeholderHoverLink/BlockchainKeywordContainer roots that
// get mounted into this DOM manually elsewhere. Cache is capped so it doesn't grow
// unbounded across a long dashboard session; raise MAX_CACHE_SIZE if a single render
// ever needs to memoize more distinct values than this.
const MAX_CACHE_SIZE = 20;

const useCreateMarkup = () => {
  const cacheRef = useRef(new Map());

  const createMarkup = (value) => {
    const cache = cacheRef.current;
    if (!cache.has(value)) {
      if (cache.size >= MAX_CACHE_SIZE) {
        cache.delete(cache.keys().next().value);
      }
      cache.set(value, { __html: value });
    }
    return cache.get(value);
  };

  return { createMarkup };
};

export default useCreateMarkup;
